import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { formEditProformaFormResource } from '@jira/router-resources__customer-service-common/src/formEditProformaFormResource.tsx';
import { formEditJirafieldsResource } from '@jira/router-resources__service-desk-customer-service-forms/src/useFormEditJirafields.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { csmExperienceFormEditRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceFormEditRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { helpCenterSettingFormEditAppPageEntryPoint } from './ui/form-edit/index.tsx';

export const csmExperienceFormEditRouteEntry: Route = createEntry(
	csmExperienceFormEditRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-form-edit',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? helpCenterSettingFormEditAppPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			formEditJirafieldsResource,
			resourceWithCondition(() => fg('csm_conditional_form_fields'), formEditProformaFormResource),
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
